import React from "react";
import { Reveal } from "../lib/anim";
import { useMedia } from "../context/MediaContext";
import { Play } from "lucide-react";

const About = () => {
  const { about } = useMedia();
  const video = about.find((m) => m.kind === "video");

  return (
    <section id="apropos" data-testid="about-section" className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-40">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-5 relative">
          <Reveal>
            <div data-testid="about-video-frame" className="relative overflow-hidden rounded-sm border border-white/10 bg-[#0a0a0a] aspect-[4/5]">
              {video ? (
                <video data-testid="about-video" className="w-full h-full object-cover" src={video.url} controls playsInline preload="none" poster={video.poster || about.find((m) => m.kind === "image")?.url} />
              ) : (
                <div className="absolute inset-0 grid place-items-center text-center px-8">
                  <div>
                    <span className="grid place-items-center w-20 h-20 rounded-full border border-[#D4AF37]/50 text-[#D4AF37] mx-auto">
                      <Play size={26} className="ml-1" />
                    </span>
                    <p className="eyebrow text-[9px] mt-6">Vidéo de présentation</p>
                    <p className="font-serif italic text-2xl text-[#F5F5F0] mt-2">Bientôt disponible</p>
                    <p className="text-[#71717a] text-xs mt-3">Découvrez notre présentation en vidéo et notre vision.</p>
                  </div>
                </div>
              )}
            </div>
          </Reveal>
          <div className="absolute -bottom-6 -right-4 lg:-right-8 bg-[#050505] border border-[#D4AF37]/40 px-6 py-4">
            <span className="font-serif text-5xl gold-text">100%</span>
            <span className="block eyebrow text-[9px] mt-1">Sur-mesure</span>
          </div>
        </div>

        <div className="lg:col-span-7">
          <Reveal><p className="eyebrow mb-6">À propos</p></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#F5F5F0]">
              Votre image, <span className="italic gold-text">notre priorité</span>.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-[#A1A1AA] text-lg leading-relaxed max-w-2xl">
              Créateurs de vidéos publicitaires immersives, nous accompagnons les entreprises, commerces,
              agences immobilières, hôtels, restaurants, boutiques de luxe, boutiques de proximité,
              concessions automobiles et marques qui souhaitent moderniser leur communication.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <p className="mt-6 text-[#A1A1AA] leading-relaxed max-w-2xl">
              VF Création Vidéo Immersive est une entreprise familiale. Nous unissons notre créativité et
              notre passion des nouvelles technologies pour imaginer des expériences visuelles sur mesure
              qui captent l'attention, renforcent votre image de marque et laissent une impression durable.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
